"use strict";
/*
 *  Filename........: axios.ts
 *  Project.........: heilpferde-elearning
 *  @copyright......: YBM Deutschland Andy Puderbach und Stephan Wienczny GBR
 *  @version........: 1.0
 *
 *  @since..........: 29.03.21, 10:10
 *  @author.........: robin
 *
 *  @brief..........:
 */
Object.defineProperty(exports, "__esModule", { value: true });
var axios = require('axios');
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */
var token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    // @ts-ignore
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}
else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
exports.default = axios;
